import React from "react";
import { Outlet } from "react-router-dom";
import RouteSeoDefaults from "../seo/RouteSeoDefaults";

export default function RootLayout() {
  return (
    <>
      <RouteSeoDefaults />
      <Outlet />
    </>
  );
}
